export default "__VITE_ASSET__BWHfWjOU__"